import { AccessToken, AuthPlugin, GetTokenOptions } from '@jarvis/jweb-core'
import { JarvisAuthProvider } from '@jarvis/web-http'
import { Logger } from './helperMethods'

export class AuthProvider implements JarvisAuthProvider {
  accessToken = ''
  Auth: AuthPlugin
  shouldLogTokenValue: boolean

  constructor(authPlugin: AuthPlugin, shouldLogTokenValue: boolean) {
    this.Auth = authPlugin
    this.shouldLogTokenValue = shouldLogTokenValue
  }

  async getAccessToken(forceRefresh?: boolean) {
    if (this.accessToken.length > 0 && !forceRefresh) {
      return this.accessToken
    }
    if (this.Auth) {
      try {
        const options = {
          tokenProviderOptions: {
            tokenType: 'user',
            allowUserInteraction: false,
            allowNetworkAccess: true,
            requireFreshToken: forceRefresh
          }
        } as GetTokenOptions
        const { tokenValue } = (await this.Auth.getToken(
          options
        )) as AccessToken

        if (this.shouldLogTokenValue) {
          Logger.error('Access token retrieved:', tokenValue)
        }

        if (tokenValue) {
          this.accessToken = tokenValue
        }
      } catch (err) {
        Logger.log(err.toString())
      }
    }
    return this.accessToken
  }
}
